/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CountryMFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 한국어 국가명 */
    koreanCountryName: string;
    /** 국제 전화 코드 */
    internationalDialingCodes: string;
    /** ISO 3166-1 alpha-2 국가 코드 */
    countryCodeISOAlpha2: string;
    /** ISO 3166-1 alpha-3 국가 코드 */
    countryCodeISOAlpha3: string;
    /** 영어 국가명 */
    englishCountryName: string;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    registAlimTalkTemplateCode?: string;
    registAlimTalkTemplateName?: string;
    registAlimTalkContent?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CountryMFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 한국어 국가명 */
    koreanCountryName: string;
    /** 국제 전화 코드 */
    internationalDialingCodes: string;
    /** ISO 3166-1 alpha-2 국가 코드 */
    countryCodeISOAlpha2: string;
    /** ISO 3166-1 alpha-3 국가 코드 */
    countryCodeISOAlpha3: string;
    /** 영어 국가명 */
    englishCountryName: string;
    /** 삭제 여부 */
    isRemoved?: boolean;
    /**
     * 생성 일시
     * @format date
     */
    createdAt?: string;
    /**
     * 마지막 수정 일시
     * @format date
     */
    updatedAt?: string;
    registAlimTalkTemplateCode?: string;
    registAlimTalkTemplateName?: string;
    registAlimTalkContent?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface CountryMFindHandlerParams {
  _id?: string;
  koreanCountryName?: string;
  internationalDialingCodes?: string;
  countryCodeISOAlpha2?: string;
  countryCodeISOAlpha3?: string;
  englishCountryName?: string;
  isRemoved?: boolean;
  registAlimTalkTemplateCode?: string;
  registAlimTalkTemplateName?: string;
  registAlimTalkContent?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type CountryMFindHandlerData = CountryMFindHandlerResponse;

export interface CountryMFindOneHandlerParams {
  _id?: string;
  koreanCountryName?: string;
  internationalDialingCodes?: string;
  countryCodeISOAlpha2?: string;
  countryCodeISOAlpha3?: string;
  englishCountryName?: string;
  isRemoved?: boolean;
  registAlimTalkTemplateCode?: string;
  registAlimTalkTemplateName?: string;
  registAlimTalkContent?: string;
}

export type CountryMFindOneHandlerData = CountryMFindOneHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description Get a Country Informations
     *
     * @tags V3-Country
     * @name CountryMFindHandler
     * @summary Get a Country Informations
     * @request GET:/v3/api/countries/m/find
     * @secure
     * @response `200` `CountryMFindHandlerData` success
     */
    countryMFindHandler: (query: CountryMFindHandlerParams, params: RequestParams = {}) =>
      this.request<CountryMFindHandlerData, any>({
        path: `/v3/api/countries/m/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a Country Information
     *
     * @tags V3-Country
     * @name CountryMFindOneHandler
     * @summary Get a Country Information
     * @request GET:/v3/api/countries/m/find/one
     * @secure
     * @response `200` `CountryMFindOneHandlerData` success
     */
    countryMFindOneHandler: (query: CountryMFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<CountryMFindOneHandlerData, any>({
        path: `/v3/api/countries/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
